var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.7725 22.6943L17.5761 16.5969C19.1988 14.834 20.1958 12.5024 20.1958 9.93682C20.195 4.44852 15.6744 0 10.0976 0C4.5208 0 0.000244141 4.44852 0.000244141 9.93682C0.000244141 15.4251 4.5208 19.8736 10.0976 19.8736C12.5072 19.8736 14.7172 19.0402 16.4531 17.6546L22.6736 23.776C22.9767 24.0746 23.4687 24.0746 23.7718 23.776C24.0756 23.4775 24.0756 22.9929 23.7725 22.6943ZM10.0976 18.3448C5.37902 18.3448 1.55387 14.5804 1.55387 9.93682C1.55387 5.29321 5.37902 1.52884 10.0976 1.52884C14.8162 1.52884 18.6414 5.29321 18.6414 9.93682C18.6414 14.5804 14.8162 18.3448 10.0976 18.3448Z","fill":"#231F20"}));
}

Search.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Search;

Search.default = Search;
